import React from 'react';
import { Gift, Users } from 'lucide-react';
import { StatusBadge } from './CompClientsList';

function Group({ title, rows, action, theme }) {
  const dark = theme === 'dark';
  if (!rows?.length) return null;
  return (
    <div className="mb-4">
      <h4 className={`text-xs uppercase tracking-wide mb-2 ${dark ? 'text-gray-500' : 'text-gray-400'}`}>{title}</h4>
      <div className="grid gap-2">
        {rows.map(r => (
          <div key={`${r.kind}:${r.id}`} className={`flex items-center justify-between px-4 py-3 rounded-xl border ${dark ? 'border-gray-700 bg-gray-800/40' : 'border-gray-200 bg-white'}`}>
            <div className="min-w-0">
              <div className="font-semibold truncate">{r.company_name}</div>
              <div className={`text-xs truncate ${dark ? 'text-gray-400' : 'text-gray-500'}`}>{r.contact_email || 'no email'}</div>
            </div>
            <div className="flex items-center gap-3">
              <StatusBadge status={r.comp_status} dark={dark} />
              {action && action(r)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function CompSearchResults({ results, onComp, onResend, theme }) {
  const btn = 'flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md bg-blue-600 text-white hover:bg-blue-700';
  const empty = !results.already_comped?.length && !results.in_candidate_list?.length && !results.existing_clients?.length;
  return (
    <div>
      <Group title="Already comped" rows={results.already_comped} theme={theme}
        action={(r) => r.comp_status === 'invited'
          ? <button className="text-xs text-blue-600 hover:underline" onClick={() => onResend(r)}>Resend</button> : null} />
      <Group title="In File-Review list" rows={results.in_candidate_list} theme={theme}
        action={(r) => <button className={btn} onClick={() => onComp(r)}><Gift size={13} /> Comp</button>} />
      <Group title="Existing clients" rows={results.existing_clients} theme={theme}
        action={(r) => <button className={btn} onClick={() => onComp(r)}><Users size={13} /> Comp</button>} />
      {empty && (
        <div className="text-sm text-gray-400 py-6 text-center">No matches — use “Add comp client” to create a new one.</div>
      )}
    </div>
  );
}
